module.exports = __webpack_public_path__ + "static/img/product_images_big02_h5_zh.a5a7240.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_big02_h5_zh.png
// module id = LSNg
// module chunks = 34